<template>
  <div class="home">
    <v-container class="mt-0 pt-0">
      <NavbarSecondary />
      <HomeCarousel />
      <v-row>
        <!-- Premium dialog -->
        <v-dialog v-model="dialogPremium" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              Premium Auction
            </v-card-title>

            <v-card-text class="body-1 pt-4">
              Premium auctions are auctions that require more than a single
              token to place a successful bid. In general those are a higher
              value items.
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialogPremium = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Premium Standard -->
        <v-dialog v-model="dialogStandard" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              Standard Auction
            </v-card-title>

            <v-card-text class="body-1 pt-4">
              Standard auctions are auctions that require only a single token to
              place a successful bid.
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialogStandard = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-col class="pt-0">
          <v-card elevation="0">
            <!-- Single auction -->
            <v-row dense>
              <v-col cols="12">
                <v-pagination
                  v-if="auctions.length > 0"
                  v-model="page"
                  :length="pagination.totalPages"
                  total-visible="15"
                ></v-pagination>
              </v-col>
              <v-col
                :cols="xsColumns"
                :md="mdColumns"
                v-for="auction in pagination.renderedAuctions"
                :key="auction.Id"
              >
                <v-card
                  :class="{ sold: !auction.Active }"
                  class="pa-0"
                  elevation="2"
                  outlined
                  :ripple="false"
                >
                  <v-card-title
                    class="text-center text-truncate mt-2 col-12 py-2 subtitle-1 font-weight-medium pt-0 d-block text-capitalize"
                  >
                    <a class="mt-0 pt-0" :href="`/auctions/${auction.Id}`">
                      {{ auction.Title }}
                    </a>
                  </v-card-title>

                  <v-divider></v-divider>
                  <a :href="`/auctions/${auction.Id}`">
                    <v-img
                      height="160px"
                      contain
                      :src="auction.ImageMain"
                    ></v-img>

                    <v-card-text
                      class="text-center text-h4 pa-0 mb-2 grey--text text--darken-3"
                    >
                      {{ auction.CurrentBidString }}</v-card-text
                    >
                    <div v-if="auction.TimeLeft < 12">
                      <v-card-text class="text-center body-1 mt-2 pa-0">
                        <p class="grey--text text--darken-3">
                          {{
                            auction.CurrentBid > 49
                              ? auction.CurrentBidder
                              : "No bids yet"
                          }}
                        </p>
                      </v-card-text>
                    </div>
                    <v-card-text
                      :class="[!auction.Active ? 'red--text' : 'green--text']"
                      class="text-center text-h4 pa-0"
                      >{{ time(auction.TimeLeft) }}</v-card-text
                    >
                  </a>
                  <v-card-actions>
                    <v-row class="d-flex justify-center">
                      <v-col class="pa-0" cols="12">
                        <div>
                          <v-col cols="12">
                            <div
                              v-if="auction.TimeLeft > 12"
                              class="text-center"
                            >
                              <p class="mb-2">
                                Starts {{ datetimeToLocShort(auction.EndTime) }}
                              </p>
                              <p class="custome-text mb-0">
                                bidding starts last 10 seconds
                              </p>
                            </div>
                            <div v-else>
                              <v-btn
                                height="45px"
                                color="deep-orange accent-2 text-white"
                                white
                                :href="`/auctions/${auction.Id}`"
                                block
                                class="text-capitalize text-h6 my-2 mx-0 white--text"
                                elevation="2"
                              >
                                Start bidding!
                              </v-btn>
                            </div>
                          </v-col>
                        </div>
                      </v-col>
                      <v-col class="pt-0 pb-0" cols="12">
                        <div class="d-flex justify-center align-center">
                          <a
                            class="ml-3 font-weight-bold"
                            :href="`/auctions/${auction.Id}`"
                            >More details</a
                          >
                          <v-spacer></v-spacer>
                          <ShareButton class="mt-6 mr-n3" :social="social" />
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" offset-md="3" class="pt-5">
                <v-card v-if="auctions.length < 1" light elevation="13">
                  <v-card-title>Site Temporarily Closed</v-card-title>
                  <v-card-subtitle class="pt-5 pb-0"
                    >Dear valued customer,</v-card-subtitle
                  >
                  <v-card-text class="py-0">
                    Our site is temporarily closed until further notice, we
                    apologize for the inconvenience.
                  </v-card-text>
                  <v-card-text class="pt-0"
                    >We will be back shortly with more exciting auctions and
                    bigger saving oppertunities, in the meantime if you have any
                    questions or concenrs please do not hesitate to contact us
                    at
                    <a href="mailto:auctions@pjili.com"
                      >auctions@pjili.com</a
                    ></v-card-text
                  >
                </v-card>
                <v-pagination
                  v-if="auctions.length > 0"
                  v-model="page"
                  :length="pagination.totalPages"
                  total-visible="15"
                ></v-pagination>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <IdleAlert @resumePolling="pollData()" />
    <v-dialog
      v-if="!isAuthenticated"
      v-model="welcomeModal.dialog"
      max-width="680"
      overlay-opacity="0.85"
      persistent
    >
      <v-system-bar dark>
        <v-spacer></v-spacer>
        <v-btn
          id="no-background-hover"
          :ripple="false"
          icon
          @click="dismissWelcomeModal"
        >
          <v-spacer></v-spacer>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>
      <WelcomeVideo :maxHeight="450" ref="video" />
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import IdleAlert from "@/components/IdleAlert";
import ShareButton from "@/components/ShareButton";
import cfg from "@/cfg";
import utils from "@/utils/utils.js";
import { mapState, mapActions } from "vuex";
import HomeCarousel from "@/components/HomeCarousel";
import WelcomeVideo from "@/components/WelcomeVideo";
import NavbarSecondary from "@/components/NavbarSecondary.vue";

export default {
  name: "Home",
  components: {
    IdleAlert,
    HomeCarousel,
    ShareButton,
    WelcomeVideo,
    NavbarSecondary,
  },
  data() {
    return {
      dialogPremium: false,
      dialogStandard: false,
      loading: null,
      cfg,
      auctions: [],
      page: 1,
      auctionsPerPage: 8,
      pagination: {
        renderedAuctions: [],
        pageStart: 0,
        pageEnd: 6,
        totalPages: null,
      },
      polling: null,
      xsColumns: 12,
      mdColumns: 12,
      social: [
        {
          color: "#3B5998",
          link: `https://www.facebook.com/sharer/sharer.php?u=https://auctions.pjili.com/`,
          icon: "mdi-facebook",
          tooltipText: "Share on Facebook",
        },
        {
          color: "#326ada",
          link:
            "https://twitter.com/share?url=https://auctions.pjili.com/;hashtags=pjili-auctions",
          icon: "mdi-twitter",
          tooltipText: "Share on Twitter",
        },
        {
          color: "blue",
          link:
            "mailto:?Subject=Pjili Auctions&body=I saw this cool site and thought to share it with you!  https://auctions.pjili.com/",
          icon: "mdi-email",
          tooltipText: "Share via email",
        },
      ],
    };
  },
  computed: {
    registerURL() {
      if (this.$store.getters.referralId !== null) {
        return (
          this.$cfg.REGISTER_URL +
          "?referral_inviter=" +
          this.$store.getters.referralId
        );
      } else {
        return this.$cfg.REGISTER_URL;
      }
    },
    ...mapState(["welcomeModal", "isAuthenticated", "user", "idle"]),
  },
  watch: {
    auctions: function (newAuctions) {
      if (newAuctions.length > 1 && newAuctions.length < 3) {
        this.mdColumns = 6;
      } else if (newAuctions.length >= 3) {
        this.mdColumns = 3;
      }

      if (newAuctions.length > 1) {
        this.xsColumns = 6;
      }

      this.setPagination(this.pagination.pageStart, this.pagination.pageEnd);
    },
    // watch welcome modal to stop vide if running
    "welcomeModal.dialog": function (newValue) {
      let video = this.$refs.video._vnode.elm;
      if (newValue === false) {
        video.pause();
        video.currentTime = 0;
      }
    },
    page: {
      immediate: true,
      handler(value) {
        this.setPageEnd(value);
      },
    },
  },
  methods: {
    ...mapActions(["dismissWelcomeModal"]),
    login() {
      window.location = cfg.LOGIN_URL;
    },
    time(duration) {
      return utils.msToTime(duration);
    },
    money(cents) {
      return utils.toMoney(cents);
    },
    datetimeToLoc(datetime) {
      return utils.DateTimeZuluToLocal(datetime);
    },
    datetimeToLocShort(datetime) {
      return utils.DateTimeZuluToLocalShort(datetime);
    },
    pollData() {
      if (this.polling === null) {
        this.polling = setInterval(() => {
          axios
            .get(cfg.API_URL + "auctions/?active=true")
            .then((res) => {
              this.auctions = res.data;
            })
            .catch((err) => console.error(err));
        }, 350);
      }
    },
    async setPagination(startIndex, endIndex) {
      // const auctions = await this.auctions;
      this.pagination.totalPages = await Math.ceil(
        this.auctions.length / this.auctionsPerPage
      );
      this.pagination.renderedAuctions = await this.auctions.slice(
        startIndex,
        endIndex
      );
    },
    setPageEnd(value) {
      // this function takes an integer to set the start and end indexes to show auctions per page
      this.pagination.pageEnd = value * this.auctionsPerPage;
      this.pagination.pageStart =
        this.pagination.pageEnd - this.auctionsPerPage;
      this.setPagination(this.pagination.pageStart, this.pagination.pageEnd);
    },
  },
  created() {
    // instantiate active auctions on created and then poll every 350 milliseconds
    axios
      .get(cfg.API_URL + "auctions?active=true")
      .then((res) => {
        this.auctions = res.data;
      })
      .then(() => {
        this.setPagination(0, 5); // set pagination start from 0 - 5 indexes
      })
      .catch((err) => console.error(err));

    this.pollData();
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  onActive() {
    //
  },
  onIdle() {
    clearInterval(this.polling);
    this.polling = null;
    this.$store.dispatch("showIdleDialog");
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
}
.custome-text {
  font-size: 12px;
  font-weight: bold;
}
</style>
